import { IGeocoding } from 'types/graphqlTypes'

export const getGeocodingCityState = (data?: Partial<IGeocoding>[]): string => {
  if (!data || data.length < 1) {
    return ''
  }
  const { city, stateCode } = data[0]
  return city && stateCode ? `${city}, ${stateCode}` : ''
}
